// prompts.<area>.<key>: the suggested questions (services/platform-agent/platformAgentSuggestions.js), sent as typed.
// {{dish}} is a dish on the restaurant's menu, {{amount}} an amount in its currency (both from the picker).
export default {
  title: 'Ciao {{first_name}}, di cosa hai bisogno per {{restaurant}}?',
  title_no_name: 'Ciao, di cosa hai bisogno per {{restaurant}}?',
  text: 'Posso rispondere alle domande su {{restaurant}} e apportare modifiche per te. Nulla cambia finché non lo approvi.',
  suggestions: 'Suggerimenti',
  // No restaurant selected (D18): Amigo asks which restaurant; the prompts let it ask for the restaurant's name.
  no_restaurant: {
    title: 'Ciao {{first_name}}, per quale ristorante?',
    title_no_name: 'Ciao, per quale ristorante?',
    text: 'Indica il ristorante nel messaggio e ci lavoro, senza aprirlo prima. Nulla cambia finché non lo approvi.',
    prompts: {
      sunday_hours: "Cambia l'orario della domenica di un ristorante in 12:00–21:00",
      close_several: 'Chiudi più ristoranti il 24 dicembre',
    },
  },
  prompts: {
    reports: {
      top_dishes: 'Quali sono stati i 10 piatti più venduti il mese scorso?',
      sales_vs_last_month: 'Come sono andate le vendite rispetto al mese scorso?',
    },
    menu: {
      raise_dish_price: 'Aumenta il prezzo di {{dish}} di {{amount}}',
      dish_sold_out: 'Segna {{dish}} come esaurito',
      dishes_without_photo: 'Quali piatti non hanno una foto?',
    },
    hours: {
      holiday_hours: 'Cambia i nostri orari di apertura per il 24 dicembre',
    },
    order_settings: {
      minimum_order: "Aumenta l'ordine minimo a {{amount}}",
    },
    marketing: {
      promo_code: 'Crea un codice promozionale del 10 % per questo weekend',
    },
    my_info: {
      phone_number: 'Aggiorna il nostro numero di telefono',
    },
  },
};
